import styled from 'styled-components';
import AddGuestSvg from '../../assets/mytrips/add-guest.svg';

const AddGuestIcon = styled(AddGuestSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default AddGuestIcon;
